import React from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Heart, GraduationCap, Stethoscope, MapPin } from 'lucide-react';
export function AboutPage() {
  return <>
      <Section className="py-20" background="offwhite" data-id="element-241">
        <div className="text-center mb-12" data-id="element-242">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-243">
            About Farasha Medical Aid
          </h1>
          <p className="text-xl font-inter text-neutral-charcoal max-w-3xl mx-auto" data-id="element-244">
            Bridging the gap between medical surplus and scarcity through
            compassionate action.
          </p>
        </div>
      </Section>
      <Section background="white" data-id="element-245">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-246">
          <div data-id="element-247">
            <div className="rounded-2xl overflow-hidden shadow-lg" data-id="element-248">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nbJVafVZgRcxD2AxVMVQyD/0225681B-F332-4CF8-BE10-DDAFB26CF5D9_1_105_c.jpg" alt="Natasha Khalil, Founder of Farasha Medical Aid" className="w-full h-full object-cover" data-id="element-249" />
            </div>
          </div>
          <div data-id="element-250">
            <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-251">
              Meet Our Founder
            </h2>
            <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-252">
              Natasha Khalil is a first-generation Egyptian-Mexican American
              from Los Angeles, whose immigrant parents instilled in her the
              values of resilience, humility, and service.
            </p>
            <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-253">
              Inspired by her father's experiences in Egypt, where healthcare
              access was often limited, Natasha committed herself to advancing
              health with dignity and equity for all.
            </p>
            <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-254">
              At Loyola Marymount University, she earned a B.A. in Psychology,
              studying the intersection of mental health, physical wellness, and
              social conditions that shape health outcomes.
            </p>
          </div>
        </div>
      </Section>
      <Section background="sand" data-id="element-255">
        <div className="mb-12" data-id="element-256">
          <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-6 text-center" data-id="element-257">
            The Meaning Behind Farasha
          </h2>
          <div className="grid md:grid-cols-2 gap-12" data-id="element-258">
            <div data-id="element-259">
              <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-260">
                "Farasha" means "butterfly" in Arabic, honoring Natasha's late
                grandmother, Kamilia. The name reflects our belief that focused,
                evidence-based interventions can create meaningful
                transformation—just as a butterfly effect can generate
                significant change from small actions.
              </p>
              <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-261">
                Our logo combines the butterfly symbol with the medical
                caduceus, representing our commitment to healthcare
                transformation and our Egyptian heritage.
              </p>
            </div>
            <div className="flex justify-center items-center" data-id="element-262">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vJ4LnEANA2qYvkkH1pNfQy/design-d5307099-5cbb-4264-b386-3c96f879a243.png" alt="Farasha Medical Aid Logo" className="h-64 w-auto" data-id="element-263" />
            </div>
          </div>
        </div>
      </Section>
      <Section background="white" data-id="element-264">
        <div className="max-w-4xl mx-auto" data-id="element-265">
          <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-8 text-center" data-id="element-266">
            Our Founder's Vision
          </h2>
          <div className="space-y-8" data-id="element-267">
            <div className="flex gap-6" data-id="element-268">
              <div className="flex-shrink-0" data-id="element-269">
                <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-270">
                  <Heart size={24} className="text-white" data-id="element-271" />
                </div>
              </div>
              <div data-id="element-272">
                <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-2" data-id="element-273">
                  Inspired by Personal Experience
                </h3>
                <p className="font-inter text-neutral-charcoal" data-id="element-274">
                  Turning insight into action, Natasha founded Farasha Medical
                  Aid after witnessing the stark contrast between medical
                  surplus in U.S. hospitals and the scarcity faced by monastery
                  clinics in Egypt.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-275">
              <div className="flex-shrink-0" data-id="element-276">
                <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-277">
                  <GraduationCap size={24} className="text-white" data-id="element-278" />
                </div>
              </div>
              <div data-id="element-279">
                <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-2" data-id="element-280">
                  Academic Foundation
                </h3>
                <p className="font-inter text-neutral-charcoal" data-id="element-281">
                  With a background in psychology and health sciences, Natasha
                  approaches healthcare challenges with an understanding of how
                  mental health, physical wellness, and social conditions
                  intersect.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-282">
              <div className="flex-shrink-0" data-id="element-283">
                <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-284">
                  <Stethoscope size={24} className="text-white" data-id="element-285" />
                </div>
              </div>
              <div data-id="element-286">
                <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-2" data-id="element-287">
                  Future in Medicine
                </h3>
                <p className="font-inter text-neutral-charcoal" data-id="element-288">
                  Currently preparing for medical school, Natasha aims to
                  combine compassionate patient care with systems-level
                  improvements in access, logistics, and culturally responsive
                  practice.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-289">
              <div className="flex-shrink-0" data-id="element-290">
                <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-291">
                  <MapPin size={24} className="text-white" data-id="element-292" />
                </div>
              </div>
              <div data-id="element-293">
                <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-2" data-id="element-294">
                  Global Impact, Local Roots
                </h3>
                <p className="font-inter text-neutral-charcoal" data-id="element-295">
                  Natasha's multicultural background informs her approach to
                  global health challenges, with a focus on closing resource
                  gaps and strengthening community health systems in underserved
                  regions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>
      <Section background="deep-blue" data-id="element-296">
        <div className="text-center" data-id="element-297">
          <h2 className="text-3xl font-playfair font-bold mb-6" data-id="element-298">
            Join Our Mission
          </h2>
          <p className="text-xl font-inter mb-8 max-w-3xl mx-auto" data-id="element-299">
            Help us continue delivering critical medical supplies to underserved
            communities in Egypt.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-300">
            <Button href="/donate" size="lg" data-id="element-301">
              Make a Donation
            </Button>
            <Button href="/get-involved" variant="secondary" size="lg" data-id="element-302">
              Get Involved
            </Button>
          </div>
        </div>
      </Section>
    </>;
}